module.exports = __webpack_public_path__ + "img/intro-dhg1.7d2a3d4f.png";